import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "react-tooltip";

type Props = {
  id: string;
  text: string;
  className?: string;
};
export const TooltipInfo = ({ id, text, className }: Props) => (
  <div className={className}>
    <div
      data-tooltip-id={id}
      data-tooltip-content={text}
      data-tooltip-place="top"
    >
      <InformationCircleIcon className="h-5 w-5 text-indigo-600" />
    </div>
    <Tooltip id={id} />
  </div>
);
